'use client'
import useOnMouseAndScroll from '@/shared/hooks/useOnMouseAndScroll'
import { useAds } from '@/shared/revive-ads/ads-context'
import { useEffect } from 'react'

const CleverCode = () => {
  const { isAdsActive } = useAds()
  const { isLoaded } = useOnMouseAndScroll()

  useEffect(() => {
    if (!isLoaded || !isAdsActive) return

    const script = document.createElement('script')
    script.id = 'CleverCoreLoader88240'
    script.src = 'https://scripts.cleverwebserver.com/60dce8e7ee8f636dad944f24ef10b86f.js'
    script.async = true
    script.defer = true

    // Get frame ID with type safety
    const frameId = window.frameElement?.getAttribute('id') || ''
    const target = window.name || frameId

    // Set attributes
    script.setAttribute('data-target', target)
    script.setAttribute('data-callback', 'put-your-callback-function-here')
    script.setAttribute('data-callback-url-click', 'put-your-click-macro-here')
    script.setAttribute('data-callback-url-view', 'put-your-view-macro-here')

    // Find target node for script insertion
    let targetNode: HTMLElement | null
    try {
      targetNode =
        parent.document.getElementsByTagName('script')[0] ||
        document.getElementsByTagName('script')[0]
    } catch (e) {
      targetNode =
        document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]
    }

    if (targetNode?.parentNode) {
      targetNode.parentNode.insertBefore(script, targetNode)
    }

    // Cleanup
    return () => {
      const existingScript = document.getElementById('CleverCoreLoader88240')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [isLoaded, isAdsActive])

  return null
}

export default CleverCode
